import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet-async';
import { Row, Col } from '@thd-olt-component/react-elements';
import { GlobalContext } from '@thd-olt-global/global-provider-component';
import Carousel from '@thd-olt-component/thd-carousel';
import LayoutManager from '@thd-olt-component/layout-manager';
import withPageChange from '../../components/PageChange';
import Helpers from '../../helpers/Helpers';

const catHref = '/b/Home-Decor/N-5yc1vZas6p';
const furnitureHref = '/b/Furniture/N-5yc1vZc7pc';
const homeOfficeHref = '/b/Furniture-Home-Office-Furniture/N-5yc1vZc7np';
const accentTablesHref = '/b/Furniture-Living-Room-Furniture-Accent-Tables/N-5yc1vZc7nz';
const pipHref = '/p/Baxton-Studio-Amaris-5-Piece-Black-Leather-Reclining-Sectional-28862-7896-HD/304217938';
const collectionHref = '/collection/patio/category/Family-311423205';
const searchHref = '/s/sofa?NCNI-5';
const pepHref = '/pep/Baxton-Studio-Amaris-5-Piece-Black-Leather-Reclining-Sectional-28862-7896-HD/304217938';
const browseSearchHref = '/b/Lighting-Sconces/N-5yc1vZc7pi/Ntk-semanticsearch/Ntt-lights?NCNI-5';
const browseHref = '/b/Home-Decor-Luggage/N-5yc1vZc419';
const browseEtchPlpHref = '/b/Furniture-Kitchen-Dining-Room-Furniture-Dining-Room-Sets/N-5yc1vZcetr';

const collectionhrefs = {
  list: '/collection/Home-Decor/Company-Cotton-Percale-Collection/Family-306050997?omsid=305199648',
  ibt: '/collection/Kitchen/Cooling-Ceramic-Collection/Family-311372814?omsid=300243236',
  grouped: '/collection/bath/test-collection/Family-311423205',
  groupedList: '/collection/Kitchen/Cambridge-Kitchen-Cabinets-in-Satin-White/Family-313423205'
};

const sku = {
  itemId: '123',
  hasCollectionId: true
};

const CustomTextComponent = ({ weight = 'normal', children }) => (
  <div className={`text-${weight}`}>
    {children}
  </div>
);
CustomTextComponent.propTypes = {
  weight: PropTypes.string,
  children: PropTypes.node
};
CustomTextComponent.defaultProps = {
  weight: 'normal',
  children: null
};

class HomePage extends Component {
  static backgroundImages = [
    'https://images.homedepot-static.com/lifestyleimages/1024x682/85912049-ef4c-4208-94ba-7c4776a420290.jpeg',
    'https://images.homedepot-static.com/lifestyleimages/1024x682/bcd6d5d4-a73b-42ed-a5cd-1607dd9617e70.jpeg',
    'https://images.homedepot-static.com/lifestyleimages/1024x682/057b3ef2-a9b7-48d4-82f0-69beee2ca6f30.jpeg',
    'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/ES218/14-15-ES218-GlobalCoastalKitchen-C5-820x545.jpg'
  ]

  static contextType = GlobalContext;

  state = {
    children: [],
    amountOfTiles: 4
  };

  componentDidMount() {
    this.setChildrenElements(this.state.amountOfTiles);
  }

  setChildrenElements = (amountOfTiles) => {
    let children = [...Array(amountOfTiles)].map((x, i) => {
      const colors = ['lightgrey', 'dimgrey', 'darkgrey', 'grey'];
      const index = 1 + i;
      const backgroundColor = colors[Math.floor(Math.random() * colors.length)];
      const backgroundImage = HomePage.backgroundImages[i] || HomePage.backgroundImages[0];
      return (
        <div
          style={{ height: '400px', backgroundColor, backgroundImage: `url(${backgroundImage})` }}
          key={i.toString()}
        />
      );
    });

    this.setState({ children });
  };


  getBusinessRules = () => {
    return {
      filters: {
        '#fbt': [{
          // value: true,
          fn: (input) => {
            if (!input.sku) return false;
            return sku.hasCollectionId;
          }
        }]
      },
      sort: {
        '#email': [{
          fn: (input) => {
            if (input.category === 'wallpaper') return 0;
            return null;
          }
        }]
      }
    };
  }

  handleClick = (e, url) => {
    const { push } = this.props;
    e.preventDefault();
    Helpers.pushWrapper({
      event: e,
      url,
      push
    });
  };

  render() {
    const { linkType } = this.props;

    return (
      <Row className="isBound">
        <Col>
          <Helmet title="Home Page" />
          <div className="home-page">
            <LayoutManager
              name="Home Page"
              input={{ sku, page: 'home', category: 'wallpaper' }}
            >
              <LayoutManager.Group name="Hero">
                <Row>
                  <Col>
                    <Carousel showDots multiItem={false} >
                      { this.state.children }
                    </Carousel>
                  </Col>
                </Row>
              </LayoutManager.Group>
              <LayoutManager.Group name="Links">
                <CustomTextComponent>
                  <Row>
                    <Col>
                      <ul>
                        <li><a href="/" >Home</a></li>
                        <li>
                          <a
                            href={pipHref}
                            onClick={e => this.handleClick(e, pipHref)}
                            target={linkType}
                          >
                            PIP
                          </a>
                        </li>
                        <li>
                          <a
                            href={collectionhrefs.list}
                            onClick={e => this.handleClick(e, collectionhrefs.list)}
                            target={linkType}
                          >
                            Collections (LIST)
                          </a>
                        </li>
                        <li>
                          <a
                            href={collectionhrefs.ibt}
                            onClick={e => this.handleClick(e, collectionhrefs.ibt)}
                            target={linkType}
                          >
                            Collections (IBT)
                          </a>
                        </li>
                        <li>
                          <a
                            href={collectionhrefs.grouped}
                            onClick={e => this.handleClick(e, collectionhrefs.grouped)}
                            target={linkType}
                          >
                            Collections (grouped)
                          </a>
                        </li>
                        <li>
                          <a
                            href={collectionhrefs.groupedList}
                            onClick={e => this.handleClick(e, collectionhrefs.groupedList)}
                            target={linkType}
                          >
                            Collections (grouped list)
                          </a>
                        </li>
                        <li>
                          <a
                            href={pepHref}
                            onClick={e => this.handleClick(e, pepHref)}
                            target={linkType}
                          >
                            PEP
                          </a>
                        </li>
                        <li>
                          <a
                            href={furnitureHref}
                            onClick={e => this.handleClick(e, furnitureHref)}
                            target={linkType}
                          >
                            Browse - Furniture
                          </a>
                        </li>
                        <li>
                          <a
                            href={homeOfficeHref}
                            onClick={e => this.handleClick(e, homeOfficeHref)}
                            target={linkType}
                          >
                            Browse - Home Office
                          </a>
                        </li>
                        <li>
                          <a
                            href={accentTablesHref}
                            onClick={e => this.handleClick(e, accentTablesHref)}
                            target={linkType}
                          >Browse - Accent Tables
                          </a>
                        </li>
                        <li>
                          <a
                            href={catHref}
                            onClick={e => this.handleClick(e, catHref)}
                            target={linkType}
                          >Browse - Content Only
                          </a>
                        </li>
                        <li>
                          <a
                            href={browseHref}
                            onClick={e => this.handleClick(e, browseHref)}
                            target={linkType}
                          >Browse - PLP Only
                          </a>
                        </li>
                        <li>
                          <a
                            href={browseEtchPlpHref}
                            onClick={e => this.handleClick(e, browseEtchPlpHref)}
                            target={linkType}
                          >Browse - Content And PLP
                          </a>
                        </li>
                        <li>
                          <a
                            href={searchHref}
                            onClick={e => this.handleClick(e, searchHref)}
                            target={linkType}
                          >Search
                          </a>
                        </li>
                        <li>
                          <a
                            href={browseSearchHref}
                            onClick={e => this.handleClick(e, browseSearchHref)}
                            target={linkType}
                          >
                            Browse / Search
                          </a>
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </CustomTextComponent>
              </LayoutManager.Group>
            </LayoutManager>
          </div>
        </Col>
      </Row>
    );
  }
}

HomePage.propTypes = {
  linkType: PropTypes.string,
  push: PropTypes.func.isRequired,
};

HomePage.defaultProps = {
  linkType: '_self',
};

export default withPageChange(HomePage);
